module.exports = {"640181001":"城区街道","640181100":"东塔镇","640181101":"郝家桥镇","640181102":"崇兴镇","640181103":"宁东镇","640181104":"马家滩镇","640181105":"临河镇","640181200":"梧桐树乡","640181201":"白土岗乡","640181400":"灵武农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/640181.json
// module id = 3172
// module chunks = 0